module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sub_title":"Shopping cart"}}')
  delete Component.options._Ctor
}
